module.exports = __webpack_public_path__ + "img/icon_enterpriserealty_overview_02.f7ca6d2f.svg";